import axios from '@/lib/axios'
import {
  buildAdminRequestConfig,
  type OrganizationId,
  type ScopedAdminQueryKey,
} from '@/lib/organization-scoping'
import type { QueryFunctionContext } from '@tanstack/react-query'
import type { CheckoutSettings } from './checkout-settings.types'

export async function getCheckoutSettings({
  queryKey: [{ organizationId }],
}: QueryFunctionContext<ScopedAdminQueryKey>) {
  return axios.get<CheckoutSettings>(
    '/checkout-settings',
    buildAdminRequestConfig({ organizationId })
  )
}

export async function updateCheckoutSettings({
  organizationId,
  ...values
}: CheckoutSettings & { organizationId: OrganizationId }) {
  return axios.put<CheckoutSettings>(
    '/checkout-settings',
    values,
    buildAdminRequestConfig({ organizationId })
  )
}
